export enum CallStatus {
  IDLE = 'idle',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ERROR = 'error',
  LISTENING = 'Listening',
  THINKING = 'Thinking',
  SPEAKING = 'Speaking',
  TIMEOUT = 'Timeout',
}

export const API = {
  CREATE_SESSION: {
    path: '/chat-sessions/create',
    method: 'POST',
  },
};
